import { getUser } from '../services/userService'

import types from './types'

const { FETCH_USER } = types

function fetchGetUser(token) {
  return dispatch =>
    getUser(token)
      .then(user => {
        dispatch({
          type: FETCH_USER,
          state: {
            ...user,
            token
          }
        })
        return user
      })
      .catch(error => {
        console.log('Erro em #fetchGetUser()')
        console.log(error)
      })
}

export default fetchGetUser



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchGetUser.js